module.exports = __webpack_public_path__ + "assets/img/Logo-footer.43df0e2a.svg";